import ActionTypes from '../actions/types';

// define node types
/* export type State = {
	all: array,
	initial: object,
	current: object,
	seekposition: object,
	isTutorialOn: bool,
}*/

// set initial states, self-explanatory const name.

const initialState = {
  all: [],
  initial: null,
  current: null,
  seekposition: 0,
  isTutorialOn: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_ALL_PLAYER_SRC:
    case ActionTypes.UPDATE_ALL_PLAYER_SRC:
      return {
        ...state,
        all: action.payload,
      };
    case ActionTypes.SET_INITIAL_PLAYER_SRC:
      return {
        ...state,
        initial: action.payload,
      };
    case ActionTypes.SET_CURRENT_PLAYER_SRC:
      return {
        ...state,
        current: action.payload,
      };
    case ActionTypes.UPDATE_SEEK_POSITION:
      return {
        ...state,
        seekposition: action.payload,
      };
    case ActionTypes.UNSET_TUTORIAL:
      return {
        ...state,
        isTutorialOn: false,
      };
    default:
      return state;
  }
}
